module.exports = __webpack_public_path__ + "static/media/10.2b34d1c8.png";